export enum EnumFormaPago {
  Domiciliacion = 1,
  Transferencia,
  Compensacion
}
